module.exports = __webpack_public_path__ + "static/media/benefits6.78164012.png";